import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IFeatureSetPreviewStyles {
  root?: IStyle;
  listView?: IStyle;
  listViewWrap?: IStyle;
}

export interface IFeatureSetPreviewClassNames {
  root: string;
  listView: string;
  listViewWrap: string;
}

export const featureSetPreviewStylesDefault = (theme: IH2OTheme): Partial<IFeatureSetPreviewStyles> => ({
  root: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    marginTop: 1,
  },
  listView: {
    flex: 1,
    padding: 24,
    paddingRight: 18,
    backgroundColor: theme.palette?.white,
    minHeight: 0,
    minWidth: 0,
  },
  listViewWrap: {
    overflow: 'auto',
    height: '100%',
  },
});
